export const getCookieDomain = () => {
  return window.location.hostname.split('.').slice(-2).join('.');
};
